import block from './block/index';
import buttonGroup from './buttonGroup/index';
import echart from './echarts/index';
import headerBar from './headerBar/index';
import headerBlock from './headerBlock/index';

export default {
    block,
    'button-group':buttonGroup,
    echart,
    'header-bar':headerBar,
    'header-block':headerBlock
}